__turbopack_context__.v({
  "intake-form": "IntakeForm-module-scss-module__vkrRSq__intake-form",
});
